module.exports = __webpack_public_path__ + "static/media/alert.6979f6e2.svg";